import { dateTimestampProvider } from '../scheduler/dateTimestampProvider';
import { map } from './map';
export function timestamp(timestampProvider = dateTimestampProvider) {
    return map((value) => ({ value, timestamp: timestampProvider.now() }));
}
